module.exports = __webpack_public_path__ + "img/article_ad_banner_02.d8854672.png";